// import React, { useState } from 'react';
// import { BrowserRouter as Router, Routes, Route, Outlet, useNavigate } from 'react-router-dom'; // Added useNavigate
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom'; // Added useNavigate
import { SignedIn, SignedOut, SignIn, SignUp, RedirectToSignIn } from "@clerk/clerk-react"; // Import Clerk components

// Components
import Navbar from './components/Navbar';
import GameContainer from './components/GameContainer'; // Fixed import path - removing pages/
// import { GameProvider } from './context/GameContext'
//commit to make deployment

// Pages
import LandingPage from './pages/LandingPage';
import LevelMapPage from './pages/LevelMapPage';
import FlipCardsPage from './pages/FlipCardsPage';
import MissionsPage from './pages/MissionsPage';
import ChallengesPage from './pages/ChallengesPage';
import InstructionsPage from './pages/InstructionsPage';

import './App.css';

// --- LAYOUT COMPONENT ---
const GameLayout = () => {
  return (
    <div className="flex flex-col h-screen w-full bg-[#050505] text-white overflow-hidden font-sans">

      {/* 1. TOP NAVBAR */}
      <Navbar />

      {/* 2. MAIN CONTENT AREA */}
      <div className="flex-1 overflow-hidden relative">
        <div className="h-full w-full overflow-y-auto scrollbar-hide">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default function App() {
  return (
    <Router>
      <Routes>

        {/* PUBLIC ROUTE: Landing Page */}
        <Route path="/" element={<LandingPage />} />

        {/* AUTHENTICATION ROUTES */}
        <Route path="/sign-in/*" element={<div className="flex items-center justify-center h-screen bg-black"><SignIn routing="path" path="/sign-in" /></div>} />
        <Route path="/sign-up/*" element={<div className="flex items-center justify-center h-screen bg-black"><SignUp routing="path" path="/sign-up" /></div>} />

        {/* PROTECTED ROUTES */}
        <Route
          element={
            <>
              <SignedIn>
                <GameLayout />
              </SignedIn>
              <SignedOut>
                <RedirectToSignIn />
              </SignedOut>
            </>
          }
        >
          <Route path="/game" element={<GameContainer />} />
          <Route path="/map" element={<LevelMapPage />} />
          <Route path="/flipcards" element={<FlipCardsPage />} />
          <Route path="/missions" element={<MissionsPage />} />
          <Route path="/challenges" element={<ChallengesPage />} />
          <Route path="/instructions" element={<InstructionsPage />} />
        </Route>

      </Routes>
    </Router>
  );
}